import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { LibRecategorisationIconV2Component } from './lib-recategorisation-icon-v2.component';

@NgModule({
  declarations: [LibRecategorisationIconV2Component],
  imports: [CommonModule],
  exports: [LibRecategorisationIconV2Component],
})
export class LibRecategorisationIconV2Module {}
